export default function collectionToHashMap(
  collection: any[] = [],
  key: string
) {
  return collection.reduce((map, object) => {
    map[object[key]] = object;
    return map;
  }, {});
}
